import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { $a } from 'shared-base';
import { ContentInvitation } from './ContentInvitation';

export type ContentInvitationContainerProps = {};

export function ContentInvitationContainer(_props: ContentInvitationContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);
  const user = useSelector(selectors.base.$user);
  const { isAdhocRunning } = appState;

  const callbacks = useMemo(
    () => ({
      onJoin: () => {
        dispatch($a('TESTERS', 'join'));
      },
    }),
    []
  );

  return <ContentInvitation isRunning={isAdhocRunning} user={user} callbacks={callbacks} />;
}

export default ContentInvitationContainer;
